module.exports = __webpack_public_path__ + "img/pc_vr1.e63604ff.png";